import { useTranslation } from 'react-i18next'
import { MdFileDownload } from 'react-icons/md'
const { startCase } = require('lodash')

const MarketingView = ({ setViewShow, item }) => {
  const { t } = useTranslation()
  const downloadFile = item?.file
  const username = item?.userData

  return (
    <div>
      <div className='justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none'>
        <div className='relative w-auto my-6 mx-auto max-w-3xl'>
          <form className='sm:py-4 sm:px-2 py-8 px-7'>
            <div className='border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none min-w-[762px]'>
              <div className='flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t'>
                <h3 className='text-xl font-semibold'>{t('O_VIEW_USER')}</h3>
                <button
                  className=' ml-auto flex items-center justify-center  text-black border-2 rounded-full  h-8 w-8 float-right text-3xl leading-none font-extralight outline-none focus:outline-none'
                  onClick={() => setViewShow(false)}
                >
                  <span className=' text-[#B8BBBF]  text-4xl ' title='Close'>
                    ×
                  </span>
                </button>
              </div>
              <div className='relative p-6 flex-auto overflow-y-auto max-h-[80vh]'>
                <div className=' border-2 rounded-md p-5'>
                  <div className='grid grid-cols-2 '>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('O_SUBJECT_LINE')}:</strong>
                      </div>
                      <div>{startCase(item?.subjectLine)}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('O_SEND_TO')}:</strong>
                      </div>
                      <div>{startCase(item?.sendTo)}</div>
                    </div>
                    <div className='mb-3'>
                      <div className=''>
                        <strong>{t('User Names')}:</strong>
                      </div>
                      <div>
                        {username.length > 0
                          ? username
                              .map(user => user.firstName + ' ' + user.lastName)
                              .join(', ')
                          : 'All users'}
                      </div>
                    </div>
                    {downloadFile && (
                      <div className='mb-3'>
                        <div className=''>
                          <strong>{t('File')}:</strong>
                        </div>
                        <div>
                          <a
                            href={downloadFile}
                            className='flex items-center justify-between '
                            title='Download'
                            download
                          >
                            {item?.file.slice(-12)}{' '}
                            <span className='h-full'>
                              {' '}
                              <MdFileDownload className='h-4' />
                            </span>
                          </a>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className='mb-4 mt-2'>
                    <div className=''>
                      <strong>{t('O_MARKETING_DESCRIPTION')}:</strong>
                    </div>
                    <div className='break-words'>
                      {startCase(item?.description) || 'N/A'}
                    </div>
                  </div>
                </div>
              </div>
              <div className='flex items-center justify-center p-6 border-t border-solid border-slate-200 rounded-b'>
                <button
                  className='text-black bg-[#E1E1E1] font-normal px-12 py-2.5 text-sm outline-none focus:outline-none rounded mr-6  ease-linear transition-all duration-150'
                  type='button'
                  onClick={() => setViewShow(false)}
                >
                  {t('O_CLOSE')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div className='opacity-25 fixed inset-0 z-40 bg-black' />
    </div>
  )
}

export default MarketingView
